export const IS_LOADING_SEARCH = 'IS_LOADING_SEARCH';
export const GET_SEARCH = 'GET_SEARCH';
export const FAIL_SEARCH = 'FAIL_SEARCH';